import React from "react";
import { Link } from "react-router-dom";
import { Package, Heart, Wallet, Share2, MapPin, User, Building2, ShieldCheck, Bell } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const CARDS = [
  [User, "Profile", "/account/profile", "Name, contact & personal details"],
  [MapPin, "Addresses", "/account/addresses", "Manage delivery addresses"],
  [ShieldCheck, "Security", "/account/security", "Password, verification & sessions"],
  [Bell, "Notifications", "/account/notifications", "Account & security updates"],
  [Package, "My Orders", "/orders", "Track and manage your orders"],
  [Heart, "Wishlist", "/wishlist", "Products you saved"],
  [Wallet, "Wallet", "/wallet", "Balance & transactions"],
  [Share2, "Referral", "/referral", "Share & earn rewards"],
];

export default function Account() {
  const { user, logout, wishlist, cartCount } = useStore();
  if (!user || user === false) return null;

  return (
    <div data-testid="account-overview">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[["Wishlist", wishlist.length], ["Cart Items", cartCount], ["Orders", 0], ["Rewards", "₹0"]].map(([l, v]) => (
          <div key={l} className="rounded-xl border border-border bg-card p-4 text-center">
            <div className="text-2xl font-bold text-secondary">{v}</div>
            <div className="text-xs text-stone-500">{l}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map(([Icon, title, to, desc]) => (
          <Link key={title} to={to} data-testid={`account-card-${title.toLowerCase().replace(/ /g, "-")}`} className="rounded-xl border border-border bg-card p-5 card-hover flex items-start gap-3">
            <div className="h-11 w-11 rounded-lg bg-accent text-secondary grid place-items-center shrink-0"><Icon size={20} /></div>
            <div>
              <h3 className="font-semibold text-stone-900">{title}</h3>
              <p className="text-sm text-stone-500">{desc}</p>
            </div>
          </Link>
        ))}
        {user.role === "business_buyer" && (
          <Link to="/business/rfqs" data-testid="account-card-wholesale-rfqs" className="rounded-xl border border-border bg-card p-5 card-hover flex items-start gap-3">
            <div className="h-11 w-11 rounded-lg bg-accent text-secondary grid place-items-center shrink-0"><Building2 size={20} /></div>
            <div><h3 className="font-semibold text-stone-900">Wholesale RFQs</h3><p className="text-sm text-stone-500">Quote requests & vendor quotations</p></div>
          </Link>
        )}
        {user.role === "vendor" && (
          <Link to="/vendor/onboarding" data-testid="account-card-vendor-onboarding" className="rounded-xl border border-border bg-card p-5 card-hover flex items-start gap-3">
            <div className="h-11 w-11 rounded-lg bg-accent text-secondary grid place-items-center shrink-0"><Building2 size={20} /></div>
            <div><h3 className="font-semibold text-stone-900">Vendor Onboarding</h3><p className="text-sm text-stone-500">Business info, KYC & application status</p></div>
          </Link>
        )}
      </div>

    </div>
  );
}
